module.exports = __webpack_public_path__ + "static/scan-9b03c380a1348ff84ec59479e344635a.jpg";